import {
  WSGrid,
  WSPage,
  WSPageToolbar,
  WSPageToolbarAction,
  WSPillProps
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useBrowserPageTitle } from "../../../../components/BrowserPageTitle/BrowserPageTitle";
import { WSQueries } from "../../../../query/WSQuery";
import {
  useQueryBenefitsEnrollment,
  useQueryBenefitsService
} from "../../../../query/benefits";
import { useUserId } from "../../../../query/hooks/helpers";
import { openInNewTab } from "../../../../utils/openInNewTab";
import { Benefit } from "../../data";
import { selectorBenefitPrimaryAction } from "../../selectors/selectorBenefitPrimaryAction";
import { selectorShouldShowMemberAndGroupInfo } from "../../selectors/selectorShouldShowMemberAndGroupInfo";
import { BenefitDetailSections } from "./BenefitDetailSections";
import { BenefitDetailSidebar } from "./BenefitDetailSidebar";

type Props = {
  benefit: Benefit;
  onBack: () => void;
};

export const BenefitDetail: React.FC<Props> = props => {
  const userId = useUserId();

  const queryEnrollment = useQueryBenefitsEnrollment(userId);
  const queryService = useQueryBenefitsService();

  const { benefit } = props;

  useBrowserPageTitle(`Benefits - ${benefit.mainHeader}`);

  return (
    <WSQueries queries={{ queryEnrollment, queryService }}>
      {({ queryEnrollmentData, queryServiceData }) => {
        const shouldShowMemberAndGroupInfo =
          selectorShouldShowMemberAndGroupInfo({
            sidebarHideMemberIds: benefit.sidebarHideMemberIds,
            enrollment: queryEnrollmentData
          });

        const action = selectorBenefitPrimaryAction({
          benefit,
          serviceState: queryServiceData.serviceState
        });

        const pill: WSPillProps | undefined =
          !benefit.hideCost && !benefit.costIsNotIncluded
            ? { text: "Included", theme: "success" }
            : undefined;

        let toolbarAction: WSPageToolbarAction | undefined;
        switch (action.kind) {
          case "external":
            toolbarAction = {
              label: action.label,
              buttonKind: "Primary",
              onClick: () => openInNewTab(action.url)
            };
            break;
          case "pending":
            toolbarAction = {
              label: action.label,
              buttonKind: "Primary",
              disabled: true
            };
            break;
        }

        return (
          <WSPage colorBackground="gray50">
            <WSPageToolbar
              breadcrumbs={[
                { label: "Benefits", onClick: props.onBack },
                { label: benefit.mainHeader }
              ]}
              title={benefit.mainHeader}
              titlePill={pill}
              actions={toolbarAction ? [toolbarAction] : undefined}
            />
            <WSGrid data-testid="benefitContent">
              <WSGrid.Item span={{ s: "8" }}>
                <BenefitDetailSections benefit={benefit} />
              </WSGrid.Item>
              <WSGrid.Item span={{ s: "4" }}>
                <BenefitDetailSidebar
                  benefit={benefit}
                  memberNumber={
                    queryEnrollmentData.wingspanBenefits?.memberNumber || "--"
                  }
                  groupNumber={
                    queryEnrollmentData.wingspanBenefits?.groupNumber || "--"
                  }
                  showCtaAndContactInfo={action.kind === "none"}
                  showMemberAndGroupInfo={shouldShowMemberAndGroupInfo}
                />
              </WSGrid.Item>
            </WSGrid>
          </WSPage>
        );
      }}
    </WSQueries>
  );
};
